import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import project from "./project";
import dashboard from "./dashboard";
import window from "./window";
import model_viewer from "./model-viewer";
import modals from "./modals";
import user_profile from "./userprofile";
import schedule from "./schedule";
import rfq from "./rfq";
import adminUser from "./admin/user";
import dealer from "./admin/dealer";
import contractor from "./admin/contractor";
import architect from "./admin/architect";
import AppModule from "./app";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    toast: {
      show: false,
      message: null,
      color: null
    }
  },
  getters: {
    getToast: state => state.toast
  },
  mutations: {
    setToast: (state, payload) => (state.toast = payload)
  },
  modules: {
    app: AppModule,
    adminUser,
    dealer,
    contractor,
    architect,
    auth,
    project,
    dashboard,
    window,
    model_viewer,
    modals,
    user_profile,
    schedule,
    rfq
  }
});
